import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbAlertModule,
  NgbModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { SharePipesModule } from '../core/pipes/pipes.module';
import { TranslationModule } from '../i18n/translation.module';
import { ComponentsShareModule } from './components/components.share.module';
import { DateTimePickerModule } from './components/date-time-picker/date-time-picker.module';
import { FormKitModule } from './components/form-kit/form-kit.module';
import { SmartSendMapControlModule } from './components/smart-send-map-control/smart-send-map-control.module';
import { ChipListModule } from './global/chip-list/chip-list.module';
import { ConfirmDialogModule } from './global/confirm-dialog/confirm-dialog.module';
import { DynamicTableModule } from './global/dynamic-table/dynamic-table.module';
import { EmptyModule } from './global/empty/empty.module';
import { ExpandItemModule } from './global/expand-item/expand-item.module';
import { ExpandTextClickModule } from './global/expand-text-click/expand-text-click.module';
import { ExpandTextModule } from './global/expand-text/expand-text.module';
import { FieldSearcherModule } from './global/field-searcher/field-searcher.module';
import { FieldSorterModule } from './global/field-sorter/field-sorter.module';
import { FormBtnsModule } from './global/form-btns/form-btns.module';
import { ListGroupItemModule } from './global/list-group-item/list-group-item.module';
import { LoadingBarModule } from './global/loading-bar/loading-bar.module';
import { LoadingDialogModule } from './global/loading-dialog/loading-dialog.module';
import { MessageDialogModule } from './global/message-dialog/message-dialog.module';
import { PageBodyModule } from './global/page-body/page-body.module';
import { PageHeaderModule } from './global/page-header/page-header.module';
import { PageTemplateModule } from './global/page-template/page-template.module';
import { PaginatorModule } from './global/paginator/paginator.module';
import { SearchBoxModule } from './global/search-box/search-box.module';
import { TableOperationsModule } from './global/table-operations/table-operations.module';
import { TablePreloadingModule } from './global/table-preloading/table-preloading.module';
import { TdValueModule } from './global/td-value/td-value.module';
import { MaterialModule } from './modules/material/material.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NgbPaginationModule,
    NgbAlertModule,
    TranslationModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    ShareDirectivesModule,
    NgxMaterialTimepickerModule,
    SharePipesModule,
    ComponentsShareModule,
    InlineSVGModule,
    SmartSendMapControlModule,
    ChipListModule,
    ConfirmDialogModule,
    DynamicTableModule,
    EmptyModule,
    ExpandItemModule,
    ExpandTextModule,
    ExpandTextClickModule,
    FieldSearcherModule,
    FieldSorterModule,
    FormBtnsModule,
    ListGroupItemModule,
    LoadingBarModule,
    LoadingDialogModule,
    MessageDialogModule,
    PageBodyModule,
    PageHeaderModule,
    PageTemplateModule,
    PaginatorModule,
    SearchBoxModule,
    TableOperationsModule,
    TablePreloadingModule,
    TdValueModule,
    FormKitModule,
    DateTimePickerModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    NgbAlertModule,
    NgbModule,
    ShareDirectivesModule,
    NgxMaterialTimepickerModule,
    SharePipesModule,
    ComponentsShareModule,
    InlineSVGModule,
    SmartSendMapControlModule,
    ChipListModule,
    ConfirmDialogModule,
    DynamicTableModule,
    EmptyModule,
    ExpandItemModule,
    ExpandTextModule,
    ExpandTextClickModule,
    FormBtnsModule,
    ListGroupItemModule,
    NgbPaginationModule,
    FieldSearcherModule,
    FieldSorterModule,
    LoadingBarModule,
    LoadingDialogModule,
    MessageDialogModule,
    PageBodyModule,
    PageHeaderModule,
    PageTemplateModule,
    PaginatorModule,
    SearchBoxModule,
    TableOperationsModule,
    TablePreloadingModule,
    TdValueModule,
    FormKitModule,
    DateTimePickerModule
  ],
})
export class ShareModule { }
